/**
 * Holds Clerk's sign-in / sign-up form (20 Oct 2026).
 *
 * Clerk's form loads separately from our page, so the logo and heading drew first and the form
 * popped in a moment later. While Clerk loads, a card the size of its form stands in its place;
 * the form then fades in over the same space, so nothing on the page moves.
 *
 * It also remembers an email typed into the form (`onEmail`): Clerk's create-account step
 * (/sign-in/create) drops what was typed on the step before, so someone joining with a code was
 * asked for their email twice.
 */
import type { FormEvent, ReactNode } from 'react'
import { ClerkLoaded, ClerkLoading } from '@clerk/clerk-react'
import { Skeleton } from '@/components/org/orgUi'

export function AuthFormFrame({ children, onEmail }: { children: ReactNode; onEmail?: (email: string) => void }) {
  const typed = (e: FormEvent<HTMLDivElement>) => {
    const t = e.target as HTMLInputElement
    if (!onEmail || t.tagName !== 'INPUT') return
    const v = t.value.trim()
    if ((t.name === 'identifier' || t.name === 'emailAddress' || t.type === 'email') && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) onEmail(v)
  }
  return (
    <>
      <ClerkLoading>
        <div aria-hidden style={{ width: 400, maxWidth: '100%', minHeight: 380, background: '#fff', borderRadius: 16, border: '1px solid #ECEAF0',
          boxShadow: '0 10px 30px rgba(40,20,70,.06)', padding: '36px 32px', display: 'flex', flexDirection: 'column', gap: 14 }}>
          <Skeleton w="55%" h={18} style={{ margin: '0 auto' }} />
          <Skeleton w="70%" h={12} style={{ margin: '0 auto 10px' }} />
          <Skeleton h={40} r={8} />
          <Skeleton w="30%" h={10} style={{ marginTop: 8 }} />
          <Skeleton h={40} r={8} />
          <Skeleton h={40} r={8} style={{ marginTop: 6 }} />
        </div>
      </ClerkLoading>
      <ClerkLoaded>
        <div onInput={typed} style={{ animation: 'lb-fade-in .25s ease-out both' }}>{children}</div>
      </ClerkLoaded>
    </>
  )
}
